export const BannerZip = [
  "./images/Main_Banner_no1.svg",
  "./images/Main_Banner_no2.svg",
  "./images/Main_Banner_no3.svg",
];

export const loadImg = {
  Main_Logo: "./icons/Outline/main_logo.svg",
  Main_TextLogo: "./icons/Outline/main_text_logo.svg",

  SNS_Insta_Logo: "./icons/Outline/sns_instagram.svg",
  SNS_YouTube_Logo: "./icons/Outline/sns_youtube.svg",
  SNS_Twitter_Logo: "./icons/Outline/sns_twitter.svg",

  Menu_Home: "./icons/Outline/Menubar_home.svg",
  Menu_Image: "./icons/Outline/Menubar_image.svg",
  Menu_Gallery: "./icons/Outline/Menubar_gallery.svg",
  Menu_Bookmark: "./icons/Outline/Menubar_bookmark.svg",
  Menu_User: "./icons/Outline/Menubar_user.svg",
  Menu_List: "./icons/Outline/menu_list.svg",

  Fill_Menu_Home: "./icons/Solid/Menubar_home.svg",
  Fill_Menu_Image: "./icons/Solid/Menubar_image.svg",
  Fill_Menu_Gallery: "./icons/Solid/Menubar_gallery.svg",
  Fill_Menu_Bookmark: "./icons/Solid/Menubar_bookmark.svg",
  Fill_Menu_User: "./icons/Solid/Menubar_user.svg",

  EX_image1: "./images/main_img_ex1.png",
  EX_image2: "./images/main_img_ex2.png",
  EX_image3: "./images/gallery_img_ex1.png",
  EX_image4: "./images/gallery_img_ex2.png",

  Event_Banner: "./images/Main_Banner_no1.svg",

  Map_all: "./icons/Outline/location_map.svg",
  Map_current1: "./icons/Outline/location_current1.svg",
  Map_current2: "./icons/Outline/location_current2.svg",

  Like_Icon: "./icons/Outline/like.svg",
  Gallery_MockUP: "./icons/Solid/Gallery_Basic_IMG.svg",

  Google_LoginBtn: "./icons/Solid/google_Btn.svg",
  Kakao_LoginBtn: "./icons/Solid/kakao_Btn.png",
  Naver_LoginBtn: "./icons/Solid/naver_Btn.png",

  User_LogOut: "./icons/Outline/user_logout.svg",
};
